export default "__VITE_PUBLIC_ASSET__c761191a__"